var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7622 17.9986V9.6184C17.7622 9.21429 17.9283 8.82674 18.2239 8.541C18.5195 8.25526 18.9204 8.09473 19.3384 8.09473H28.7957C29.2137 8.09473 29.6146 8.25526 29.9102 8.541C30.2058 8.82674 30.3719 9.21429 30.3719 9.6184V14.1894",
    stroke: "#905F31",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6431 8.09468V3.52367C25.6431 3.11957 25.4771 2.73202 25.1815 2.44627C24.8859 2.16053 24.485 2 24.0669 2H3.57621C3.15817 2 2.75726 2.16053 2.46166 2.44627C2.16606 2.73202 2 3.11957 2 3.52367V21.8077C2 22.2118 2.16606 22.5994 2.46166 22.8851C2.75726 23.1708 3.15817 23.3314 3.57621 23.3314H16.1859M22.4907 9.61835H25.6431M27.2209 27.9024C26.3849 27.9024 25.583 27.5813 24.9918 27.0098C24.4006 26.4383 24.0685 25.6632 24.0685 24.855C24.0685 24.0468 24.4006 23.2717 24.9918 22.7002C25.583 22.1288 26.3849 21.8077 27.2209 21.8077M27.2209 27.9024C28.057 27.9024 28.8588 27.5813 29.45 27.0098C30.0412 26.4383 30.3733 25.6632 30.3733 24.855C30.3733 24.0468 30.0412 23.2717 29.45 22.7002C28.8588 22.1288 28.057 21.8077 27.2209 21.8077M27.2209 27.9024V30.1879M27.2209 21.8077V19.5222M31.9984 22.1886L29.9509 23.3314M24.4925 26.3787L22.4434 27.5215M22.4434 22.1886L24.4925 23.3314M29.9509 26.3787L32 27.5215",
    stroke: "#905F31",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution);
export default __webpack_public_path__ + "static/media/solution.89236ae33eeccbd45ef3a79dc7aa1f19.svg";
export { ForwardRef as ReactComponent };